export default __webpack_public_path__ + "static/media/03-rock-dx.db41b08d.png";